<mat-card class="cityDetails-Label">
    <mat-card-header>
        <mat-card-title>
            <h4>
                {{
                    "dashboardBizzDev.overview.kpis.title.fullLabel" | translate
                }}
            </h4>
        </mat-card-title>
    </mat-card-header>
    <mat-card-content class="table-height">
        <section>
            <ng-container *ngIf="testResult && licenceCount">
                <!-- ERREUR -->
                <ng-container *ngIf="errorNumber > 0; else hasNoErrors">
                    <p
                        [ngStyle]="{
                            color: 'red',
                            cursor: 'pointer',
                            'margin-left': '15px'
                        }"
                        (click)="
                            loadPage(
                                'dashboardBizzDev/advanced-overview',
                                'errorLogMonitoring'
                            )
                        "
                    >
                        <mat-icon>error</mat-icon><b>{{ errorNumber }}</b>
                        {{
                            "dashboardBizzDev.overview.kpis.leftPanel.error.true.shortLabel"
                                | translate
                        }}
                    </p>
                </ng-container>
                <ng-template #hasNoErrors>
                    <p [ngStyle]="{ color: 'green', 'margin-left': '15px' }">
                        <mat-icon>thumb_up</mat-icon
                        >{{
                            "dashboardBizzDev.overview.kpis.leftPanel.error.false.shortLabel"
                                | translate
                        }}
                    </p>
                </ng-template>
                <!-- BBC IMPORT DATE-->
                <ng-container *ngIf="bbcNbrOfDays > 7; else bbcUpdated">
                    <p
                        [ngStyle]="{
                            color: 'red',
                            cursor: 'pointer',
                            'margin-left': '15px'
                        }"
                        (click)="
                            loadPage(
                                'dashboardBizzDev/advanced-overview',
                                'dateMonitoring'
                            )
                        "
                    >
                        <mat-icon>error</mat-icon
                        >{{
                            "dashboardBizzDev.overview.kpis.leftPanel.bbcImport.true.fullLabel"
                                | translate
                        }}
                        {{ bbcNbrOfDays | number: "1.0-0" }}
                        {{
                            "dashboardBizzDev.overview.kpis.leftPanel.bbcImport.days.fullLabel"
                                | translate
                        }}
                    </p>
                </ng-container>
                <ng-template #bbcUpdated>
                    <p [ngStyle]="{ color: 'green', 'margin-left': '15px' }">
                        <mat-icon>thumb_up</mat-icon
                        >{{
                            "dashboardBizzDev.overview.kpis.leftPanel.bbcImport.false.fullLabel"
                                | translate
                        }}
                    </p>
                </ng-template>
                <!-- TEST CHECK -->
                <ng-container
                    *ngIf="testResult.noMatchingCount > 0; else goodResults"
                >
                    <p
                        [ngStyle]="{
                            color: 'red',
                            cursor: 'pointer',
                            'margin-left': '15px'
                        }"
                        (click)="
                            loadPage(
                                'dashboardBizzDev/advanced-overview',
                                'testMonitoring'
                            )
                        "
                    >
                        <mat-icon>error</mat-icon
                        >{{ testResult.noMatchingCount }}
                        {{
                            "dashboardBizzDev.overview.kpis.leftPanel.test.true.fullLabel"
                                | translate
                        }}
                    </p>
                </ng-container>
                <ng-template #goodResults>
                    <p [ngStyle]="{ color: 'green', 'margin-left': '15px' }">
                        <mat-icon>thumb_up</mat-icon
                        >{{
                            "dashboardBizzDev.overview.kpis.leftPanel.test.false.fullLabel"
                                | translate
                        }}
                    </p>
                </ng-template>
                <!-- LICENCE -->
                <p [ngStyle]="{ 'margin-left': '15px' }">
                    <mat-icon>arrow_right_alt</mat-icon
                    >{{ licenceCount.normalLicenceNumber }}
                    {{
                        "dashboardBizzDev.overview.kpis.leftPanel.licence.normal.fullLabel"
                            | translate
                    }}
                </p>
                <p [ngStyle]="{ 'margin-left': '15px' }">
                    <mat-icon>arrow_right_alt</mat-icon
                    >{{ licenceCount.testLicenceNumber }}
                    {{
                        "dashboardBizzDev.overview.kpis.leftPanel.licence.test.fullLabel"
                            | translate
                    }}
                </p>
                <p [ngStyle]="{ 'margin-left': '15px' }">
                    <mat-icon>arrow_right_alt</mat-icon
                    >{{ licenceCount.crackLicenceNumber }}
                    {{
                        "dashboardBizzDev.overview.kpis.leftPanel.licence.crac.fullLabel"
                            | translate
                    }}
                </p>
                <!-- USERS CONNEXION NUMBER -->
                <p [ngStyle]="{ 'margin-left': '15px' }">
                    <mat-icon>arrow_right_alt</mat-icon
                    >{{ usersConnexion }}
                </p>
                <!-- OPEN TICKETS NUMBER -->
                <p [ngStyle]="{ 'margin-left': '15px' }">
                    <mat-icon>arrow_right_alt</mat-icon>{{ openTicketNumber }}
                    {{
                        "dashboardBizzDev.overview.kpis.leftPanel.openTicketNumber.fullLabel"
                            | translate
                    }}
                </p>
                <!-- EXPIRED LICENCES -->
                <p [ngStyle]="{ 'margin-left': '15px' }">
                    <mat-icon>arrow_right_alt</mat-icon>{{ expiredLicences }}
                    {{
                        "dashboardBizzDev.overview.kpis.leftPanel.expiredLicences.fullLabel"
                            | translate
                    }}
                </p>
            </ng-container>
        </section>
    </mat-card-content>
</mat-card>
